import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTextUnderline';
/** Renders an SVG icon. */
const SvgTextUnderline = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-1v10a6 6 0 0 0 12 0V6h-1a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2h-1v10a8 8 0 1 1-16 0V6H7a1 1 0 0 1-1-1M4 27a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1"
      />
    </svg>
  );
};
SvgTextUnderline.displayName = displayName;
export default SvgTextUnderline;
